import {filter, mergeMap} from 'rxjs/operators';

import {
  IDENTIFY_AUTH_EXIST_ON_DEVICE_FAIL,
  LOGOUT_SUCCESSFUL,
} from '../actionConstants';
import {resetDataStart} from '../actions';
import {cleanupLocalStorage} from '@app/localStorage';
import {Observable} from 'rxjs';
import {Action} from 'redux';

export const logoutSuccessfulEpic = (action$: Observable<Action>) =>
  action$.pipe(
    filter(
      action =>
        action.type === LOGOUT_SUCCESSFUL ||
        action.type === IDENTIFY_AUTH_EXIST_ON_DEVICE_FAIL,
    ),
    mergeMap(action =>
      cleanupLocalStorage().then(resetDataStart).catch(resetDataStart),
    ),
  );
